export * from './WixPatternsContainerProvider';
